import React from 'react'
import { Form } from '../../../lib/ui/form'
import { Separator } from '../../../lib/ui/separator'
import { useProgramSurveyForm } from './useProgramSurveyForm'
import { Button } from '~/lib/ui/button'
import { RatingField } from '../RatingField'
import { TextareaField } from '../TextareaField'
import { DatePickerField } from '../DatePickerField'
import { MultipleCheckboxesField } from '../MultipleCheckboxesField'

export default function PostProgramSurveyForm({
  questions,
  choices,
  candidateId,
  companyId,
  setError,
  setThankYou,
}) {
  const { form, onSubmit } = useProgramSurveyForm({
    surveyType: 'program_survey_post_program',
    questions,
    candidate_id: candidateId,
    company_id: companyId,
    setError,
    setThankYou,
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
        {Object.entries(questions).map(([key, question]) => {
          if (question.type === 'rating') {
            return (
              <div className="my-6 rounded-xl bg-white p-6" key={question.name}>
                <RatingField
                  name={question.name}
                  label={question.name}
                  choices={choices[key]}
                  control={form.control}
                  oneToFive={true}
                  programSurvey={true}
                />
              </div>
            )
          } else if (question.type === 'text') {
            return (
              <div className="my-6 rounded-xl bg-white p-6" key={question.name}>
                <TextareaField
                  name={question.name}
                  label={question.name}
                  control={form.control}
                  programSurvey={true}
                />
              </div>
            )
          } else if (question.type === 'date') {
            return (
              <div className="my-6 rounded-xl bg-white p-6" key={question.name}>
                <DatePickerField
                  name={question.name}
                  label={question.name}
                  control={form.control}
                  programSurvey={true}
                />
              </div>
            )
          } else if (question.type === 'checkboxes') {
            return (
              <div className="my-6 rounded-xl bg-white p-6" key={question.name}>
                <MultipleCheckboxesField
                  name={question.name}
                  label={question.name}
                  options={choices[key]}
                  control={form.control}
                  programSurvey={true}
                />
              </div>
            )
          }
        })}
        <Separator className="my-8" />

        <div className="flex w-full justify-center">
          <Button type="submit">Submit</Button>
        </div>
      </form>
    </Form>
  )
}
